<template>
    <div class="bzj_sm">
        <div class="tit">关于保证金服务</div>
        <p>为保障平台用户、卖家和买家的合法权益，创造更为便捷，诚信，安全的交易环境，本平台自2019年2月12号启用保证金 系统，卖家按照本规则缴存一定数额保证金，作为其经营行为的担保。</p><br />
        <p>1、保证金是卖家发布商品时预先交纳的诚信保证金是卖家为买家提供的一种诚信保障，</p>
        <p>2、账号下无正在挂售、审核、交易中的商品，可进行保证金提现申请。</p>
        <p>3、如果因卖家无货、虚假出售、出售成功后又取消等自身原因导致交易失败，则该笔交易的相应保证金将不退还。</p>
        <van-button round color="var(--theme)" class="know" @click="close">我已知晓</van-button>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {
            close() {
                this.$emit('closeModal')
            }
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
    .bzj_sm {
        padding: 2.4rem 2.6rem;

        .tit {
            font-size: 1.6rem;
            color: #FE6455;
            font-weight: 700;
            margin-bottom: 1.9rem;
            text-align: center;
        }

        p {
            font-size: 1.4rem;
            color: #555;
            line-height: 1.5;
        }

        .know {
            width: 24rem;
            height: 3.2rem;
            display: block;
            margin: 1.9rem auto 0;
            font-size: 1.6rem;
        }
    }
</style>